import { render, staticRenderFns } from "./CupomDescontoDetalhes.vue?vue&type=template&id=43327457&"
import script from "./CupomDescontoDetalhes.vue?vue&type=script&lang=js&"
export * from "./CupomDescontoDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports